import React from 'react';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
import { Div } from './HeroBgAnimationStyle';

const HeroBgAnimation = () => {
  const particlesInit = async (main) => {
    await loadFull(main);
  };

  return (
    <Div>
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          background: { color: 'transparent' },
          fpsLimit: 60,
          particles: {
            number: { value: 60, density: { enable: true, area: 900 } },
            color: { value: '#6366f1' },
            shape: { type: 'circle' },
            opacity: { value: 0.2, random: { enable: true, minimumValue: 0.08 } },
            size: { value: 2.5, random: { enable: true, minimumValue: 1 } },
            links: {
              enable: true,
              color: '#6366f1',
              distance: 150,
              opacity: 0.08,
              width: 1,
            },
            move: {
              enable: true,
              speed: 0.4,
              direction: 'none',
              random: false,
              straight: false,
              outModes: { default: 'out' },
              attract: { enable: false },
              parallax: { enable: true, force: 40, smooth: 10 },
            },
          },
          interactivity: {
            events: {
              onHover: { enable: true, mode: 'grab' },
              onClick: { enable: false },
              resize: true,
            },
            modes: {
              grab: { distance: 140, links: { opacity: 0.15 } },
            },
          },
          detectRetina: true,
        }}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 0,
        }}
      />
    </Div>
  );
};

export default HeroBgAnimation;
